import Chart from 'react-apexcharts';

const LineChart = (props: any) => {
  const { chartData, ...rest } = props;

  return (
    // @ts-ignore
    <Chart
      options={props.chartOptions}
      type="line"
      width="100%"
      height="100%"
      series={chartData}
      i18nIsDynamicList={true}
      {...rest}
    />
  );
};

export default LineChart;
